import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { CellType, IColumnMovingEventArgs, IGridState, IgxDialogComponent, IgxGridComponent, IgxGridStateDirective } from '@infragistics/igniteui-angular';
import { Subject, takeUntil } from 'rxjs';
import { UserService } from 'src/app/authentication/user.service';
import { GridState } from 'src/app/models/grid-state';
import { Kid } from 'src/app/models/kid';
import { Parent } from 'src/app/models/parent';
import { ParentService } from 'src/app/services/parent.service';
import { WaitIndicatorService } from 'src/app/services/wait-indicator.service';
import { restoreState } from 'src/app/shared/utils';

@Component({
    selector: 'app-edit-parents',
    templateUrl: './edit-parents.component.html',
    styleUrls: ['./edit-parents.component.scss']
})
export class EditParentsComponent implements OnInit, OnDestroy {
    @ViewChild('dialog', { static: true, read: IgxDialogComponent })
    private dialog!: IgxDialogComponent;
    @ViewChild('parentsGrid', { static: true, read: IgxGridComponent })
    private parentsGrid!: IgxGridComponent;
    @ViewChild(IgxGridStateDirective, { static: true })
    private state!: IgxGridStateDirective;

    private destroy$: Subject<void> = new Subject<void>();
    private gridName: string = 'edit-parents-grid';
    private gridState?: GridState;

    public parents: Parent[] = [];
    public editParent: Parent | undefined;
    public dialogText = 'Добави';

    constructor(
        private  parentService: ParentService,
        private userService: UserService,
        private wait: WaitIndicatorService,
        router: Router,
    ) {
        this.load();
        router.events.pipe(takeUntil(this.destroy$)).subscribe(e => {
            if (e instanceof NavigationStart) {
                if (this.gridState) {
                    this.gridState.options = this.state.getState().toString();
                    this.gridState.userId = this.userService.currentUser!.id!;
                } else {
                    this.gridState = {
                        gridName: this.gridName,
                        options: this.state.getState().toString(),
                        userId: this.userService.currentUser!.id!,
                    };
                }
                this.userService.updateGridState(this.gridState);
            }
        });
    }

    ngOnInit(): void {
        this.userService.gridStates().pipe(takeUntil(this.destroy$)).subscribe((states: GridState[]) => {
            const loaded = states.filter(s => s.gridName === this.gridName && s.userId === this.userService.currentUser!.id!)[0];
            if (loaded) {
                this.gridState = loaded;
                const gridState: IGridState = JSON.parse(this.gridState?.options ?? '');
                restoreState(gridState, this.parentsGrid);
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public parseKids = (arr: Kid[]): string => {
        return (arr || [])
            .map(e => e?.name || '').join(', ');
    }

    public updateParent = (cell: CellType): void => {
        this.editParent = cell.row.data;
        this.dialogText = 'Редактирай';
        this.dialog?.open();
    }

    public addParent = (dialog: IgxDialogComponent): void => {
        this.dialogText = 'Добави';
        dialog.open();
    }

    public saveParentDone = (parent: Parent | undefined): void => {
        if (parent) {
            const index = this.parents.findIndex(p => p.id === parent.id);
            if (index > -1) {
                this.parents.splice(index, 1, parent);
                this.parents = [...this.parents];
            } else {
                this.parents = [...this.parents, parent];
            }
        }
        this.editParent = undefined;
        this.dialog?.close();
    }

    protected columnMoving = (e: IColumnMovingEventArgs): void => {
        e.cancel = e.source.pinned;
    }

    private load = async () => {
        this.wait.show();
        this.parents = await this.parentService.all();
        this.wait.hide();
    }
}
